<script>
  import {mapActions, mapGetters} from 'vuex';
  import Brand from './brand'
  import subMenuResponsive from './subMenuResponsive.vue'

  export default{
    data(){
      return{
        meuCollapse: ''
      }
    },
    components:{
      Brand,
      subMenuResponsive
    },
    computed: {
      ...mapGetters([
        'isLogged',
        'loggedUser'
      ]),
      showBusinessLine: function () {
        if (this.$route.params.businessAreaId) {
          return (this.loggedUser.businessLines.length > 1);
        }
      },
      showContracts: function () {
        if (this.$route.params.systemId) {
          return (_.find(this.loggedUser.businessLines, {'id': this.$route.params.businessAreaId}).contracts.length > 1);
        }
      },
      contractMenuShow: function () {
        return this.$route.params.systemId
      }
    },
    methods: {
      ...mapActions(['logout']),
      doLogout () {
          this.logout()
          this.$router.push({path: '/auth'})
        },
      open: function(){
        if (this.meuCollapse == ''){
          this.meuCollapse = 'in';
        } else {
          this.meuCollapse = '';
        }
      },
      openNivel: function(id) {
        let className = document.getElementById(id).parentElement.className;
        if (className.indexOf("open") > -1) {
          document.getElementById(id).parentElement.className = "dropdown";
        } else {
          document.getElementById(id).parentElement.className = "dropdown open";
        }
      }
    }
  }

</script>

<template>
  <header>
    <nav class="navbar border-sgs">

      <div class="navbar-header">
        <button type="button" id="open" @click="open()" class="navbar-toggle collapsed" v-if="isLogged">
          <span class="icon-bar" style="background: black;"></span>
          <span class="icon-bar" style="background: black;"></span>
          <span class="icon-bar" style="background: black;"></span>
        </button>
        <a>
          <Brand/>
        </a>
      </div>

      <div id="navbar" class="collapse navbar-collapse"
           :class="meuCollapse" v-if="isLogged">
        <ul class="nav navbar-nav">
          <router-link :to="{ name: 'BusinessAreaList'}" tag="li" exact v-show="showBusinessLine">
            <a>{{$t("businessLine")}}</a>
          </router-link>
          <router-link :to="{ name: 'SystemsList'}" tag="li" exact v-show="showContracts">
            <a>{{$t("contracts")}}</a>
          </router-link>
        </ul>

        <subMenuResponsive :meuCollapse="meuCollapse" v-if="contractMenuShow" />

        <ul class="nav navbar-nav">
          <li v-if="isLogged">
            <a href="#" @click.prevent="doLogout">{{$t("logout")}}</a>
          </li>
        </ul>

      </div>
    </nav>
  </header>
</template>

<style>
  .navbar-toggle {
    margin-top: 25px;
  }
  .el-collapse-01 {
    border: none !important;
    box-shadow: none !important;
  }
  .el-collapse-01 .el-collapse-item__header {
    color: rgb(255, 102, 0) !important;
  }
  .el-collapse-01 .el-collapse-item__wrap {
    border: none;
  }
</style>



// WEBPACK FOOTER //
// MenuResponsive.vue?f0759ea2